import React from "react";
import { Box, AHText, Circle, useTime } from "arkh";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { DateTime } from "luxon";
import { OrgButton } from "../OrgHome/OrgButton";
import { FormattedMessage } from "react-intl";

const InviteExpired = (props: {
  inviteUser: () => void;
  inviteUserLoading: boolean;
}) => {
  const intl_tokens = useIntlTokens();
  return (
    <>
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHText type="title-small" spaceRight="small">
          {intl_tokens.InviteExpired}
        </AHText>
        <Circle size="dot" color="negative" />
      </Box>
      <Box
        style={{ flexDirection: "row", alignItems: "center" }}
        spaceTop="small"
      >
        <AHText type="list-item-title" style={{ flex: 1 }} spaceRight="medium">
          <FormattedMessage
            defaultMessage="The invite has expired. Please send a new one to proceed!"
            description="AccountEditInviteCardExpired invite expired description"
          />
        </AHText>
        <OrgButton
          title={intl_tokens.ResendInvite}
          backgroundColor="primary"
          tintColor="text-inverted"
          loading={props.inviteUserLoading}
          onPress={() => {
            props.inviteUser();
          }}
        />
      </Box>
    </>
  );
};

const InviteSent = (props: {
  expiresAt: string;
  createdAt: string;
  inviteUser: () => void;
  inviteUserLoading: boolean;
}) => {
  const intl_tokens = useIntlTokens();
  return (
    <>
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHText type="title-small" spaceRight="small">
          {intl_tokens.InviteSent}
        </AHText>
        <Circle size="dot" color="semiNegative" />
      </Box>
      <Box
        style={{ flexDirection: "row", alignItems: "center" }}
        spaceTop="small"
      >
        <AHText type="list-item-title" style={{ flex: 1 }} spaceRight="medium">
          <FormattedMessage
            defaultMessage={`Sent {sentAt}. Valid until {expiresAt}.`}
            description="AccountEditInviteCardSent invite sent description"
            values={{
              sentAt: DateTime.fromISO(props.createdAt).toLocaleString(
                DateTime.DATETIME_SHORT
              ),
              expiresAt: DateTime.fromISO(props.expiresAt).toLocaleString(
                DateTime.DATETIME_SHORT
              ),
            }}
          />
        </AHText>
        <OrgButton
          title={intl_tokens.ResendInvite}
          backgroundColor="surface-backgroundControl"
          tintColor="text-primary"
          loading={props.inviteUserLoading}
          onPress={() => {
            props.inviteUser();
          }}
        />
      </Box>
    </>
  );
};

export const AccountEditInviteCard = (props: {
  expiresAt: string;
  createdAt: string;
  inviteUser: () => void;
  inviteUserLoading: boolean;
}) => {
  const now = useTime();
  const hasExpired = DateTime.fromISO(props.expiresAt) < now;

  return (
    <Box
      cornerRadius="large"
      borderColor="border-primary"
      style={{
        borderWidth: 1,
      }}
      space="large"
    >
      {hasExpired ? (
        <InviteExpired
          inviteUser={props.inviteUser}
          inviteUserLoading={props.inviteUserLoading}
        />
      ) : (
        <InviteSent
          expiresAt={props.expiresAt}
          createdAt={props.createdAt}
          inviteUser={props.inviteUser}
          inviteUserLoading={props.inviteUserLoading}
        />
      )}
    </Box>
  );
};
